import React, {useEffect, useState} from 'react';
import {Container} from './DetailedMonthView.styles';

import Table from '../../../../common/Table/Table';
import TableLoader from '../../../../common/Table/TableLoader';

const DetailedMonthView = ({data, tableData}) => {
  const [isLoading, setIsLoading] = useState(true);

  const {header} = tableData;

  return (
    <Container>
      {header && <h4 className="fs16 latoBlack mb15">{header}</h4>}
      {!header ? <TableLoader /> : <Table data={data} tableData={tableData} />}
    </Container>
  );
};

export default DetailedMonthView;
